module.exports = __webpack_public_path__ + "img/icon_hk.b924a03a.png";